import { useAppSelector } from '@/store/hooks';
import { selectGreenroomMedia } from '@/store/slices/project/selectors';
import { useMemo } from 'react';

export const useGreenroomAudioMediaUrls = () => {
  const media = useAppSelector(selectGreenroomMedia);

  return useMemo(() => {
    return new Map(media?.filter((item) => item.type === 'mp3').map((item) => [item.id, item.images]));
  }, [media]);
};
